export default "__VITE_ASSET__Dx8Gi0gM__"